module.exports = __webpack_public_path__ + "media/wordschange.30cd57eb.mp4";